var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightRayBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3192,
    height: 2861,
    viewBox: "0 0 3192 2861",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3240 533.376L3217.93 347L0 529.249L22.0677 715.625L3240 533.376Z",
    fill: "url(#paint0_linear_32_2)",
    fillOpacity: 0.03
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3240 887.376L3217.93 701L0 883.249L22.0677 1069.62L3240 887.376Z",
    fill: "url(#paint1_linear_32_2)",
    fillOpacity: 0.03
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3240 1220.38L3217.93 1034L0 1216.25L22.0677 1402.62L3240 1220.38Z",
    fill: "url(#paint2_linear_32_2)",
    fillOpacity: 0.03
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3240 1560.38L3217.93 1374L0 1556.25L22.0677 1742.62L3240 1560.38Z",
    fill: "url(#paint3_linear_32_2)",
    fillOpacity: 0.03
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3240 186.376L3217.93 0L0 182.249L22.0677 368.625L3240 186.376Z",
    fill: "url(#paint4_linear_32_2)",
    fillOpacity: 0.03
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3240 1929.38L3217.93 1743L0 1925.25L22.0677 2111.62L3240 1929.38Z",
    fill: "url(#paint5_linear_32_2)",
    fillOpacity: 0.03
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3240 2309.38L3217.93 2123L0 2305.25L22.0677 2491.62L3240 2309.38Z",
    fill: "url(#paint6_linear_32_2)",
    fillOpacity: 0.03
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3240 2678.38L3217.93 2492L0 2674.25L22.0677 2860.62L3240 2678.38Z",
    fill: "url(#paint7_linear_32_2)",
    fillOpacity: 0.03
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_2",
    x1: 3228.97,
    y1: 2585.19,
    x2: 34.2433,
    y2: 2963.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_2",
    x1: 3228.97,
    y1: 2585.19,
    x2: 34.2433,
    y2: 2963.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32_2",
    x1: 3228.97,
    y1: 2585.19,
    x2: 34.2433,
    y2: 2963.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32_2",
    x1: 3228.97,
    y1: 2585.19,
    x2: 34.2433,
    y2: 2963.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32_2",
    x1: 3228.97,
    y1: 2585.19,
    x2: 34.2433,
    y2: 2963.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32_2",
    x1: 3228.97,
    y1: 2585.19,
    x2: 34.2433,
    y2: 2963.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32_2",
    x1: 3228.97,
    y1: 2585.19,
    x2: 34.2433,
    y2: 2963.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_32_2",
    x1: 3228.97,
    y1: 2585.19,
    x2: 34.2433,
    y2: 2963.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRayBg);
export default __webpack_public_path__ + "static/media/light_ray_bg.552fdb0c7b32c97136e64ddc2ce67390.svg";
export { ForwardRef as ReactComponent };